import React, {useState} from 'react'
import { useQuery, useLazyQuery, useMutation } from '@apollo/react-hooks';
import loader from '../../../images/loader.svg';
import { CLASS_TYPE } from '../../../services/constants';
import styles from './MoveClasses.module.scss'
import CreateClass from './CreateClass'
import cx from 'classnames'
import _ from 'lodash';
import { Button } from '@squirrellearningltd/go-teacher-components';
import { GET_CLASSES_QUERY } from '../../Classes/scenes/NewAcademicYear/services/graphql';
import { MOVE_STUDENTS, REMOVE_STUDENTS_FROM_SCHOOL, GET_CLASS_QUERY } from '../../Classes/scenes/MoveClass/components/services/graphql';
import { ADD_STUDENT_MUTATION, GET_YEAR_STATS, GET_FILTERED_STUDENTS,GET_UNASSIGNED_STUDENTS_QUERY  } from '../services/graphql';

const MoveClasses = ({schoolId, school, close, students, currentYear, clearStudents}) => {

    const [classes, setClasses] = useState([]);

    const [showClassForm, setShowClassForm] = useState(false);

    const classType = CLASS_TYPE.registration;

    const { data, error, loading } = useQuery(GET_CLASSES_QUERY, {
        variables: {
            includeAdminedClasses: true,

        },
        onCompleted: () => {
            setClasses(data.myClasses)
        },
        fetchPolicy: 'cache-and-network'
    });

    const handleClose = (e) => {
        close()
    }

    const getQueries = () => {
        if (currentYear === 'UPN') {
            return {
                schoolId: schoolId,
                withoutUpn: true,
            }
        } else {
            return {
                schoolId: schoolId,
                yearGroup: currentYear && currentYear.toString(),
            }
        }
    }

    const [moveStudents, { loading: moveLoading, error: errorLoading }] = useMutation(MOVE_STUDENTS, {
        awaitRefetchQueries: true,
        onCompleted: (data) => {
            if (data.addStudentsToClass.errors && data.addStudentsToClass.errors.length > 0) {
                console.log("error from backend?")
            } else {
                close()
            }
            return;
        }
        ,
        onError: (error) => {
            console.log(error)
            console.log("error")
            return;
        },
        refetchQueries: [
            {
                query: GET_UNASSIGNED_STUDENTS_QUERY,
                variables: {
                    schoolId: schoolId,
                }
            },
            {
                query: GET_FILTERED_STUDENTS,
                variables: getQueries(),
            },
            {
                query: GET_YEAR_STATS,
                variables: {
                    schoolId: schoolId,
                }
            }
        ],
    });

    const [removeStudentsFromSchool, { loading: removeLoading, error: removeError }] = useMutation(REMOVE_STUDENTS_FROM_SCHOOL, {
        awaitRefetchQueries: true,
        onCompleted: (data) => {
            if (data.removeStudentsFromSchool.errors && data.removeStudentsFromSchool.errors.length > 0) {
                console.log("error from backend?");
            } else {
                clearStudents()
                close();
            }
            return;
        }
        ,
        onError: (error) => {
            console.log(error)
            return;
        },
        refetchQueries: [
            {
                query: GET_UNASSIGNED_STUDENTS_QUERY,
                variables: {
                    schoolId: schoolId,
                }
            },
            {
                query: GET_FILTERED_STUDENTS,
                variables: getQueries(),
            },
            {
                query: GET_YEAR_STATS,
                variables: {
                    schoolId: schoolId,
                }
            }
        ],
    });

    const moveStudentsToClass = (c) => {
        let newStudents = []
        students.forEach(s => {
                newStudents.push({studentId: s, removeFromClassId: null})
        })
        moveStudents({
            variables: {
                studentsClassId: c,
                studentsData: newStudents
            }
        })
    }

    if (loading) return <div className={styles.optionsContainer} onClick={close}><img src={loader} /></div>

    if (error) return <div className={styles.optionsContainer} onClick={close}><p>Something went wrong, please try again.</p></div>

    if (data) {
        return (
        <>
            {
                showClassForm ? (
                    <div className={styles.optionsContainer} onClick={close}>
                        <div className={styles.panel} onClick={(e) => e.stopPropagation()}>
                            <div className={styles.panelLeft}>
                                {/* <CreateClassForm studentsClass={stClass} studentObjects={studentObjects} closeClassOptions={() => close()} close={() => setShowClassForm(false)} /> */}
                                <CreateClass schoolId={schoolId}  currentYear={currentYear} studentObjects={students} closeClassOptions={() => close()} close={() => setShowClassForm(false)} clearStudents={clearStudents} />
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className={styles.optionsContainer} onClick={close}>
                        <div className={styles.panel} onClick={(e) => e.stopPropagation()}>
                            <div className={styles.panelLeft} >
                                <h2>Target Class - or <Button onClick={() => setShowClassForm(true)}>Create class</Button></h2>
                                {loading ? 
                                    <p>Fetching Classes...</p> :
                                    <ul style={{ maxHeight: '600px', overflow: 'auto' }} >
                                    {
                                                    classes && classes.length > 0 && classes.filter(c => c.academicYear === school.currentAcademicYear && c.typeId === classType).length > 0 ?
                                                        _.map(classes.filter(c => c.academicYear === school.currentAcademicYear && c.typeId === classType ), c => (
                                            <li key={`class${c.id}`} className={styles.moveOptLink} onClick={() => moveStudentsToClass(c.id)}>
                                                {c.name}
                                            </li>
                                        )) 
                                        :
                                        <p>There are no registration classes for the current academic year.</p>
                                    }
                                    </ul>
                            }
                            </div>
                            <div className={styles.panelRight}>
                                <h2>Other Options</h2>
                                <ul>
                                    <li><button type="button" disabled={removeLoading} className={cx(styles.moveOptLink, 'btn-reset')} onClick={() => removeStudentsFromSchool({
                                        variables: {
                                            studentIds: students,
                                            schoolId
                                        }
                                    })}>Leaving this school</button></li>
                                    
                                    <li><button type="button" disabled={removeLoading} className={cx(styles.moveOptLink, 'btn-reset')} onClick={() => removeStudentsFromSchool({
                                        variables: {
                                            studentIds: students,
                                            schoolId,
                                            is6YearLeaver: true
                                        }
                                    })}>Year 6 Leaver</button></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                )
            }
        </>
        )
    }

    return null

}

export default MoveClasses